export const RESET_FORM = 'RESET_FORM'

export const OPTION_ENTITY_SELECTED = 'OPTION_ENTITY_SELECTED'
export const OPTION_GOAL_SELECTED = 'OPTION_GOAL_SELECTED'
export const OPTION_OBJECTIVES_SERVICES_SELECTED = 'OPTION_OBJECTIVES_SELECTED'
export const OPTION_DURATION_SELECTED = 'OPTION_DURATION_SELECTED'
export const ON_INPUT_CITIES = 'ON_INPUT_CITIES'
export const ON_INPUT_COUNTRIES = 'ON_INPUT_COUNTRIES'

export const RECEIVED_AUDIENCE = 'RECEIVED_AUDIENCE'

export const STRUCTURE_CHANGED = 'STRUCTURE_CHANGED'

export const GO_LOCATIONS = 'GO_LOCATIONS'
export const GO_DURATIONS = 'GO_DURATIONS'
